import {
  CARRIER_CHECKLIST_ACTION_TYPES,
  CARRIER_CHECKLIST_UPDATE_ACTION_TYPES,
} from 'utils/actions/carrier'

const { CHECKLIST_FAILURE, CHECKLIST_REQUEST, CHECKLIST_SUCCESS } = CARRIER_CHECKLIST_ACTION_TYPES

const {
  EDIT_CHECKLIST_FAILURE,
  EDIT_CHECKLIST_SUCCESS,
  EDIT_CHECKLIST_UPDATE,
} = CARRIER_CHECKLIST_UPDATE_ACTION_TYPES

const defaultState = {
  opsCarrierChecklistLoading: true,
  opsCarrierChecklistErrors: null,
  checklists: null,
  updating: false,
  updateError: null,
}

const carrierDocumentsCheckListsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case CHECKLIST_REQUEST: {
      return {
        ...state,
        opsCarrierChecklistLoading: true,
        opsCarrierChecklistErrors: null,
      }
    }
    case CHECKLIST_SUCCESS: {
      return {
        ...state,
        checklists: action.payload.opsCarrierChecklist,
        opsCarrierChecklistLoading: false,
        opsCarrierChecklistErrors: null,
      }
    }
    case CHECKLIST_FAILURE: {
      const {
        payload: { errors },
      } = action
      return {
        ...state,
        opsCarrierChecklistLoading: false,
        opsCarrierChecklistErrors: errors,
      }
    }
    case EDIT_CHECKLIST_UPDATE: {
      return {
        ...state,
        updating: true,
        updateError: null,
      }
    }
    case EDIT_CHECKLIST_SUCCESS: {
      return {
        ...state,
        updating: false,
        checklists: action.payload.opsCarrierChecklist,
      }
    }
    case EDIT_CHECKLIST_FAILURE: {
      return {
        ...state,
        updateError: action.error,
      }
    }
    default:
      return state
  }
}

export default carrierDocumentsCheckListsReducer
